import styled from "@emotion/styled";
import type { ReactNode } from "react";

import { FONT_WEIGHT_SEMI_BOLD, Form, FormRow, Help, Tooltip } from "@skilitics/designer-ui-components";

export const FormBody = styled.div`
  overflow: hidden;

  padding-block-start: 16px;
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  padding: 0;

  ${FormBody} {
    flex: 1 1 100%;
  }

  ${FormRow} {
    margin-block-end: 26px;
  }
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  padding: 65px 45px 0px 45px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13.5px;

  padding-block-end: 25px;
`;

export const Heading = styled.div`
  width: fit-content;

  font-size: 18px;
  font-weight: 500;

  color: ${({ theme }) => theme.generalTextIconVariant};

  border-block-end: 1px solid ${({ theme }) => theme.outline};
`;

export const SubHeading = styled.div`
  font-size: 28.8px;
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};

  color: ${({ theme }) => theme.primaryStrong};
`;

export const SwitchLabel = styled.span`
  color: ${({ theme }) => theme.generalTextIcon};

  font-size: 15.6px;
  font-weight: 500;
  line-height: 27.3px;
`;

// note: temporary until components matching figma are ready
export const HelpContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
`;

export const HelpTooltip = ({ title }: { title: ReactNode }) => (
  <Tooltip title={title}>
    <Help>?</Help>
  </Tooltip>
);
